<template lang="html">
  <div class="uk-light">
    <nav id="navbar" class="uk-navbar-container" v-bind:style="config.navStyleObject">
      <div class="uk-container">

        <div class="uk-flex uk-flex-right">
          <ul class="uk-navbar-nav uk-visible@m">
            <li>
              <router-link @click.native="refreshMain" :to="{ name: 'main', params: {} }">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: home"></span>
                Moje wizyty
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'data', params: {} }">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: user"></span>
                Moje dane
              </router-link>
            </li>
            <li>
              <a v-bind:href="menuRejestracjaLink" target="_blank">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: bookmark"></span>
                E-rejestracja
              </a>
            </li>
            <li>
              <router-link :to="{ name: 'contact', params: {} }">
                <span class="uk-icon uk-margin-small-right" uk-icon="icon: phone"></span>
                Kontakt z kliniką
              </router-link>
            </li>
          </ul>

          <ul class="uk-navbar-nav uk-hidden@m">
          </ul>

          <div class="uk-navbar-item uk-visible@m">
            <button class="uk-button uk-button-danger" id="logout_btn">
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: sign-out"></span>Wyloguj
            </button>
          </div>
        </div>

          <!--<a class="uk-navbar-item uk-logo" v-bind:href="logoLink">
      <img :src="config.logo_url" alt="Logo" style="height: 60px;" />
    </a>-->

        <div class="uk-navbar-right uk-flex-right uk-text-middle uk-hidden@m">
          <span title="Jeżeli nie zostanie wykonana żadna akcja w ciągu przedstawionego czasu, nastąpi automatyczne wylogowanie." uk-tooltip="pos: bottom" style="cursor: help;">Sesja wygaśnie za {{ $parent.sessionValidToText }}</span>
          <a class="uk-navbar-toggle" uk-navbar-toggle-icon uk-toggle="target: #offcanvas-nav"></a>
        </div>
      </div>
    </nav>
    <div id="offcanvas-nav" uk-offcanvas="overlay: true">
            <div class="uk-offcanvas-bar uk-flex uk-flex-column">

                <ul class="uk-nav uk-nav-primary ">
                  <li class="uk-text-center"><a><img :src="config.logo_url" alt="Logo" style="height: 70px;" /></a></li>
                  <hr>
                    <li><router-link @click.native="refreshMain" :to="{ name: 'main', params: {} }"><span class="uk-icon uk-margin-small-right" uk-icon="icon: home"></span>
                    Moje wizyty</router-link></li>
                    <li><router-link :to="{ name: 'data', params: {} }"><span class="uk-icon uk-margin-small-right" uk-icon="icon: question"></span>
                    Moje dane</router-link></li>
                    <li><router-link :to="{ name: 'contact', params: {} }"><span class="uk-icon uk-margin-small-right" uk-icon="icon: phone"></span>
                    Kontakt z kliniką</router-link></li>
                    <li class="uk-nav-divider"></li>
                    <li><a href="#" id="logout_btn_small" class="log-out"><span class="uk-icon uk-margin-small-right" uk-icon="icon: sign-out"></span>
                    Wyloguj</a></li>
                </ul>

          </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      menuRejestracjaLink: '',
      logoLink: ''
    }
  },
  computed: {
    config () {
      return this.$parent.config
    }
  },
  methods: {
    refreshMain ($event) {
      this.$root.$emit('refreshMain')
    }
  },
  mounted () {
    var getDomain = location.protocol + '//' + location.host
    this.$http.get(getDomain + '/config.php').then((response) => {
      var resp = response.data
      if (this.$cookie.get('aut')) {
        var token = this.$cookie.get('aut')
        this.menuRejestracjaLink = resp.menuRejestracjaLink + token
        this.logoLink = resp.logoLink
      }
    }).catch((errors) => {
      JSON.stringify(errors)
    })
  }
}
</script>

<style lang="sass" scoped>

  @import "./../../assets/theme.sass"
  @import "./../../../node_modules/uikit/src/scss/variables-theme.scss"

  .uk-offcanvas-bar
    background: #fff
    color: #000

  .uk-nav-primary *
    color: #222 !important

  // .log-out
    color: #d84863 !important

  #navbar
    background: $global-primary-background

    a.uk-active, .uk-logo
      color: #fff

    .flex-small
      @media screen and(max-width: 960px)
        display: flex
        width: 100%

    .uk-logo

      @media screen and (min-width: 1300px)
        margin-right: 285px

</style>



// WEBPACK FOOTER //
// navbar.vue?028f07a0